import CloseIcon from "@mui/icons-material/Close";
import { Grid, IconButton, MenuItem, TextField } from "@mui/material";
import { useTranslation } from "common/locales";
import { FormikErrors } from "formik";
import { GENERAL_FEED_TYPE, GENERAL_FEED_UNITS, GeneralFeed } from "model";

interface Props {
  index: number;
  singleFeed: GeneralFeed;
  handleInputChange: (
    event:
      | React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
      | React.ChangeEvent<{ value: unknown }>,
    name: string
  ) => void;
  errors?: FormikErrors<GeneralFeed>;
  remove: (index: number) => void;
}

export default function EnterFeedEventFeedDetails({
  index,
  singleFeed,
  handleInputChange,
  errors,
  remove,
}: Props) {
  const { t } = useTranslation();

  return (
    <Grid
      container
      spacing={1.5}
      sx={{
        mb: 2,
        pb: index > 0 ? 1.5 : 0,
        borderBottom: index > 0 ? "1px solid rgba(0,0,0,0.08)" : "none",
      }}
      alignItems="center"
    >
      <Grid size={{ xs: 6, sm: 3.5 }}>
        <TextField
          select
          fullWidth
          required
          size="small"
          value={singleFeed.feedType ?? ""}
          onChange={(event) => {
            handleInputChange(event, `feed[${index}].feedType`);
          }}
          error={!!errors?.feedType}
          label={t("feedPurchaseEvent.feedType.text")}
          name={`feed[${index}].feedType`}
        >
          {Object.entries(GENERAL_FEED_TYPE).map(([key, value]) => (
            <MenuItem value={value} key={key}>
              {t(`feedPurchase.feedType.option.${value}`)}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid size={{ xs: 6, sm: 3.5 }}>
        <TextField
          select
          fullWidth
          required
          size="small"
          value={singleFeed.unitType ?? ""}
          onChange={(event) => {
            handleInputChange(event, `feed[${index}].unitType`);
          }}
          error={!!errors?.unitType}
          label={t("feedPurchaseEvent.feedUnit.text")}
          name={`feed[${index}].unitType`}
        >
          {Object.entries(GENERAL_FEED_UNITS).map(([key, value]) => (
            <MenuItem value={value} key={key}>
              {t(`feedPurchase.feedUnit.option.${value}`)}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid size={{ xs: 6, sm: 3.5 }}>
        <TextField
          required
          fullWidth
          size="small"
          value={singleFeed.amount}
          type="number"
          id={`feedAmount-${index}`}
          error={!!errors?.amount}
          onChange={(event) => {
            handleInputChange(event, `feed[${index}].amount`);
          }}
          label={t("feedPurchaseEvent.feedAmount.label")}
          name={`feed[${index}].amount`}
        />
      </Grid>
      {index > 0 && (
        <Grid size="auto" sx={{ display: "flex", alignItems: "center" }}>
          <IconButton
            size="small"
            onClick={() => remove(index)}
            sx={{ color: "rgba(0,0,0,0.4)" }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Grid>
      )}
    </Grid>
  );
}
